import {
  ACCOUNTING_TABLE_NAME,
} from "../../constants";
import {store} from "@/plugins/vuex";
import AccountingSearchModel from "@/modules/setup/accounting/AccountingSearch.model";
import AccountingService from "@/modules/setup/accounting/AccountingService";

let getDefaultTableData = () => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new AccountingSearchModel(),
    extraFilters: {}
  }
};

export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      accounting: getDefaultTableData(),
    },
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: ACCOUNTING_TABLE_NAME
      });

      if (payload) {
        data = {...payload.pagination, search: payload.search, ordering: payload.ordering,};
      } else {
        data = {...currentTableData.pagination, search: currentTableData.search, ordering: ordering}
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {...data, ...searchModelData}
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }
      // 'lots' is needed for optimal selects on backend.
      data.expand = 'auction';
      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await AccountingService.getAccountingSyncLog(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new AccountingSearchModel({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
  },
  mutations: {
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
  }
}
